import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

const DashIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);
const UsersIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const BuildingIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="15"/><path d="M16 22V7M8 22V7M2 12h20M2 17h20"/>
    <path d="M12 2L2 7h20L12 2z"/>
  </svg>
);
const DocsIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
  </svg>
);
const ChartIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
  </svg>
);
const MailIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const SettingsIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);
const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

const FinderIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><path d="M11 8v6M8 11h6"/>
  </svg>
);
const InboxIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-6l-2 3h-4l-2-3H2"/>
    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
  </svg>
);
const ProspectIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 2h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/>
    <path d="M16 4h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <path d="M12 11v5M9.5 13.5h5"/>
  </svg>
);

const workspaceItems = [
  { path: '/',                label: 'Dashboard',       icon: <DashIcon />,      end: true },
  { path: '/students',        label: 'Students',        icon: <UsersIcon /> },
  { path: '/hosts',           label: 'Hosts',           icon: <BuildingIcon /> },
  { path: '/host-prospects',  label: 'Host Prospects',  icon: <ProspectIcon />,  prospectAccess: true },
  { path: '/host-finder',     label: 'Host Finder',     icon: <FinderIcon />,    hostSpecialistOnly: true },
  { path: '/doc-tracker',     label: 'Doc Tracker',     icon: <DocsIcon /> },
  { path: '/inbox',           label: 'Email Inbox',     icon: <InboxIcon /> },
  { path: '/reports',         label: 'Reports',         icon: <ChartIcon />,     adminOnly: true },
  { path: '/email-templates', label: 'Email Templates', icon: <MailIcon />,      adminOnly: true },
];

const adminItems = [
  { path: '/settings', label: 'Settings', icon: <SettingsIcon />, adminOnly: true },
];

export default function Sidebar({ isOpen, onClose }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [inboxUnread, setInboxUnread] = useState(0);

  const refreshInbox = useCallback(async () => {
    if (!user || user.role === 'student') return;
    try {
      const res = await api.get('/inbox/unread-count');
      setInboxUnread(res.data.count || 0);
    } catch { /* ignore */ }
  }, [user]);

  // Poll the inbox notifier, and refresh on focus + when a thread is read elsewhere.
  useEffect(() => {
    refreshInbox();
    const iv = setInterval(refreshInbox, 45000);
    const onUpdated = () => refreshInbox();
    window.addEventListener('inbox-updated', onUpdated);
    window.addEventListener('focus', onUpdated);
    return () => {
      clearInterval(iv);
      window.removeEventListener('inbox-updated', onUpdated);
      window.removeEventListener('focus', onUpdated);
    };
  }, [refreshInbox]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isAdmin = user?.role === 'admin';
  const isHostSpecialist = user?.is_host_specialist;
  const visibleWorkspace = workspaceItems.filter(i =>
    (!i.adminOnly || isAdmin) &&
    (!i.hostSpecialistOnly || isHostSpecialist) &&
    (!i.prospectAccess || isHostSpecialist || isAdmin)
  );
  const visibleAdmin = adminItems.filter(i => !i.adminOnly || isAdmin);

  const initials = user?.full_name
    ?.split(' ')
    .map(w => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'U';

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar${isOpen ? ' sidebar-mobile-open' : ''}`}>

        <div className="sidebar-brand">
          <div className="brand-emblem-wrap">
            <img
              src="/mcg-logo.png"
              alt="MCG"
              className="brand-mark-img"
              onError={e => {
                e.target.src = '/mcg-emblem.png';
                e.target.onerror = () => { e.target.style.display = 'none'; };
              }}
            />
          </div>
          <div className="brand-text">
            <div className="brand-name">MCG Career College</div>
            <div className="brand-sub">Career Services · Practicum</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section-label">
            <span className="nav-label">Workspace</span>
          </div>
          {visibleWorkspace.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              title={item.label}
              onClick={onClose}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              {item.path === '/inbox' && inboxUnread > 0 && (
                <span className="nav-badge">{inboxUnread > 99 ? '99+' : inboxUnread}</span>
              )}
            </NavLink>
          ))}

          {visibleAdmin.length > 0 && (
            <>
              <div className="nav-section-label">
                <span className="nav-label">Admin</span>
              </div>
              {visibleAdmin.map(item => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.end}
                  className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                  title={item.label}
                  onClick={onClose}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                </NavLink>
              ))}
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="avatar">{initials}</div>
          <div className="sidebar-user">
            <div className="name">{user?.full_name || 'User'}</div>
            <div className="role">Career Services · {user?.is_host_specialist ? 'Host Specialist' : user?.role === 'admin' ? 'Admin' : 'PC'}</div>
          </div>
          <button className="sidebar-signout" title="Sign out" onClick={handleLogout}>
            <LogoutIcon />
          </button>
        </div>

      </aside>
    </>
  );
}
